<template>
  <v-app :theme="appTheme" :class="{ 'dga-app-typography': appTheme === 'dgaTheme' }" style="min-height: 100vh; width: 100%; overflow-x: hidden">
    <!-- <NavBar v-if="$route.path != '/login' " /> -->
    <!-- <NavBar v-if="$route.path != '/login' && Snippet_Status == false " /> -->
    <NavBar
      v-if="showAppNavBar"
      v-model:imageLogo="LoginLogo"
      myEvent="LoginLogo"
    />

    <!-- <v-content> -->

    <v-main
      style="min-height: calc(100vh - 64px); width: 100%; flex: 1; overflow-x: hidden; top: 0 !important"
      :style="[
        { backgroundColor: mainBgColor },
        isFullStreamReDesignRoute
          ? 'padding-top: 0 !important; min-height: 100dvh !important; overflow: hidden !important;'
          : isPublicShellRoute
            ? 'padding-top: 0 !important; min-height: 100dvh !important; overflow-x: hidden !important;'
          : isFlowCreatorRoute
            ? 'padding-top: 10px !important;padding-bottom: 15px !important;'
            : ''
      ]"
    >
      <router-view></router-view>
    </v-main>
    <!-- </v-content> -->

    <!-- Global skeleton loader ครอบ NavBar/route transition ทั้งหมดหลัง login สำเร็จ — ใช้ pattern เดียวกับ NavBar -->
    <div v-if="postLoginSkeleton" class="superadmin-transition-shell" aria-live="polite" aria-busy="true">
      <aside class="superadmin-transition-sidebar">
        <div class="superadmin-transition-logo-row">
          <v-skeleton-loader type="avatar" class="superadmin-transition-logo-skeleton"></v-skeleton-loader>
          <div class="superadmin-transition-logo-text">
            <v-skeleton-loader type="text" width="120"></v-skeleton-loader>
            <v-skeleton-loader type="text" width="92"></v-skeleton-loader>
          </div>
        </div>
        <div class="superadmin-transition-menu">
          <v-skeleton-loader v-for="item in 8" :key="`app-superadmin-nav-skeleton-${item}`" type="list-item-avatar" class="superadmin-transition-menu-item"></v-skeleton-loader>
        </div>
      </aside>
      <section class="superadmin-transition-main">
        <header class="superadmin-transition-topbar">
          <v-skeleton-loader type="text" width="240"></v-skeleton-loader>
          <div class="superadmin-transition-topbar-actions">
            <v-skeleton-loader type="avatar" class="superadmin-transition-action"></v-skeleton-loader>
            <v-skeleton-loader type="avatar" class="superadmin-transition-action"></v-skeleton-loader>
            <v-skeleton-loader type="avatar" class="superadmin-transition-action"></v-skeleton-loader>
          </div>
        </header>
        <div class="superadmin-transition-content">
          <div class="superadmin-transition-status">
            <v-progress-circular indeterminate size="28" width="3" color="#FF4F00"></v-progress-circular>
            <div>
              <div class="superadmin-transition-title">{{ $t('saDashboardWelcome') }}</div>
              <div class="superadmin-transition-subtitle">{{ $t('loadingpleasewait') }}</div>
            </div>
          </div>
          <div class="superadmin-transition-hero">
            <v-skeleton-loader type="heading" width="300"></v-skeleton-loader>
            <v-skeleton-loader type="text" width="220"></v-skeleton-loader>
          </div>
          <div class="superadmin-transition-cards">
            <v-skeleton-loader v-for="card in 4" :key="`app-superadmin-card-skeleton-${card}`" type="card" class="superadmin-transition-card"></v-skeleton-loader>
          </div>
        </div>
      </section>
    </div>

    <!-- Global banner/popup splash (single mount) — derives target page from route -->
    <BannerPopup />

    <!-- Cookie consent banner (single mount) — แสดงครั้งแรกที่ยังไม่เคยตัดสินใจ, ซ่อนใน snippet/embed -->
    <CookieConsentBanner />
  </v-app>
</template>

<script>
import Cookies from 'js-cookie';
import NavBar from './components/NavBar.vue';
import BannerPopup from './components/BannerPopup.vue';
import CookieConsentBanner from './components/CookieConsentBanner.vue';
import Swal from 'sweetalert2';
import { ref, computed, toRef, reactive } from 'vue';
import { mapState, useStore } from 'vuex';

function hasSuperAdminTransitionQuery() {
  if (typeof window === 'undefined') return false;
  return new URLSearchParams(window.location.search).get('saTransition') === '1';
}

// เพดานเวลารอธีมจาก loader ก่อนจะยอมยิง GetConfigThem เอง (ดู bindSnippetThemeRelay)
// ตั้ง 2.5s จากตัวเลขจริง: loader ยิงที่ +0ms ได้ผลกลับ +385ms ส่วนจุดที่รอเริ่มทำงาน ~+1.4s
// ⇒ ปกติ payload มาถึงก่อนแล้ว ค่านี้จึงเป็นแค่ตาข่ายกันค้างเมื่อ loader เก่า/ยิงพลาด ไม่ใช่ค่าที่ใช้จริง
const SNIPPET_THEME_RELAY_TIMEOUT_MS = 2500;

// 🔄 AMENDMENT 2026-09-03 (S14-P9 AC14) — เพดานรอ GetConfigThem ก่อน reveal widget UI (fail-open):
// error ปกติ reveal ทันทีผ่าน error callback — timer นี้กันเฉพาะ request ค้าง (hang) ที่ callback ไม่กลับมา
const SNIPPET_THEME_HANG_TIMEOUT_MS = 5000;

export default {
  name: 'App',
  provide() {
    return {
      getStartUpImage: this.GetStartUpImage,
      Click_History_List: this.Click_History_List,
      DeleteTopicStream: this.DeleteTopicStream,
      RenameClick: this.RenameClick,
      RenameTopicStream: this.RenameTopicStream,
      keyupKeyRename: this.keyupKeyRename,
      SetStatusKeyRename: this.SetStatusKeyRename,
      GetModelFirst_Value: this.GetModelFirst_Value,
      GetModelFirst: this.GetModelFirst,
      getIMG: this.getIMG,
      NotificationTokenExpired: this.NotificationTokenExpired,
      isFeedback: ref(this.isFeedback),
      User_Id_Show: ref(this.User_Id_ShowData),
      User_Id: ref(this.User_IdData),
      Time_Delay: ref(this.Time_DelayData),
      flagShowTopic: ref(this.flagShowTopicData),
      listTopic: toRef(this, 'listTopicData'),
      TopicName: toRef(this, 'TopicNameData'),
      ModelFirst: toRef(this, 'ModelFirstData'),
      firstModel: toRef(this, 'firstModel'),
      ChatbotName: toRef(this, 'ChatbotNameData'),
      Loading_History_Status: toRef(this, 'Loading_History_Status'),
      Log_History_TopicID: toRef(this, 'Log_History_TopicIDData'),
      IsAllowImage: toRef(this, 'IsAllowImage'),
      maximumChatInput: toRef(this, 'maximumChatInput'),
      Username: toRef(this, 'username'),
      RoleId: toRef(this, 'roleId'),
      Log_History_Take: ref(this.Log_History_TakeData),
      Log_History_ID: ref(this.Log_History_IDData),
      tabSocialType: ref(this.tabSocialTypeData),
      KeyTopic: ref(this.KeyTopicData),
      Snippet_Status: ref(this.Snippet_StatusData),
      Snippet_Username: ref(this.Snippet_UsernameData),
      isAllowLLMChange: ref(this.isAllowLLMChange),
      selectedLLMModelInChat: ref(this.selectedLLMModel),
      TopicModelID: ref(this.TopicModelIDData),
      lastLLMID: ref(this.lastLLMID),

      // appState: reactive({
      //   colorThemeChat: toRef(this, "colorThemeChat")
      // }),
      colorThemeChat: computed(() => this.colorThemeChat),
      flagNav: computed(() => this.flagNav),
      LoginLogo: computed(() => this.LoginLogo),
      IconChat: computed(() => this.IconChat),
      ChatbotIcon: computed(() => this.ChatbotIcon),
      NavbarIcon: computed(() => this.NavbarIcon),
      // ChatbotName: computed(() => this.ChatbotNameData),
      FontColorTitle: computed(() => this.FontColorTitle),
      NavbarBackGround: computed(() => this.NavbarBackGround),
      SubNavbarBackGround: computed(() => this.SubNavbarBackGround),
      unreadCount: computed(() => this.unreadCountData),
      Status_Error: computed(() => this.Status_ErrorData),
      User_Id_Status: computed(() => this.User_Id_StatusData),
      LeftNavBar: computed(() => this.LeftNavBarData),
      SetPopup: ref(this.SetPopupData),
      flagGetAllTopic: computed(() => this.flagGetAllTopicData),
      miniVariant: computed(() => this.miniVariantData),
      NavbarTxtColorTheme: computed(() => this.NavbarTxtColorThemeData),
      NavbarBtnColorTheme: computed(() => this.NavbarBtnColorThemeData),
      auth_token: computed(() => this.auth_tokenData),
      TopicModelID_long: computed(() => this.TopicModelID_longData),
      StatusKeyRename: computed(() => this.StatusKeyRenameData),
      Flag_Click_History: computed(() => this.Flag_Click_HistoryData),
      isImgIconChat: computed(() => this.isImgIconChatData),
      Region: computed(() => this.Region),
      SubscriptionKey: computed(() => this.SubscriptionKey),
      IsChainMassage: computed(() => this.IsChainMassage),
      FileUploadLimit: computed(() => this.FileUploadLimit),

      // S14-P3 — snippet customization tokens (per-company), reactive so FullStreamReDesignV2.vue
      // (inject) sees the value update once configColor()'s GetConfigThem fetch resolves
      snippetGreetingTh: computed(() => this.snippetGreetingThData),
      snippetGreetingEn: computed(() => this.snippetGreetingEnData),
      snippetChipColor: computed(() => this.snippetChipColorData),
      snippetShowLogin: computed(() => this.snippetShowLoginData),
      snippetShowTranslate: computed(() => this.snippetShowTranslateData),
      snippetShowHistory: computed(() => this.snippetShowHistoryData),
      snippetShowMic: computed(() => this.snippetShowMicData),

      // S14-P4 — snippet content-customization tokens (welcome text + quick chips), same
      // reactive-provide pattern as the S14-P3 block above
      snippetWelcomeTaglineTh: computed(() => this.snippetWelcomeTaglineThData),
      snippetWelcomeTaglineEn: computed(() => this.snippetWelcomeTaglineEnData),
      snippetWelcomeSubtitle1Th: computed(() => this.snippetWelcomeSubtitle1ThData),
      snippetWelcomeSubtitle1En: computed(() => this.snippetWelcomeSubtitle1EnData),
      snippetWelcomeSubtitle2Th: computed(() => this.snippetWelcomeSubtitle2ThData),
      snippetWelcomeSubtitle2En: computed(() => this.snippetWelcomeSubtitle2EnData),
      snippetWelcomeBetaTh: computed(() => this.snippetWelcomeBetaThData),
      snippetWelcomeBetaEn: computed(() => this.snippetWelcomeBetaEnData),
      snippetQuickChipsTh: computed(() => this.snippetQuickChipsThData),
      snippetQuickChipsEn: computed(() => this.snippetQuickChipsEnData),
      // S14-P4 (follow-up) — service-menu keywords + logged-in greeting template
      snippetSuggestionKeywordsTh: computed(() => this.snippetSuggestionKeywordsThData),
      snippetSuggestionKeywordsEn: computed(() => this.snippetSuggestionKeywordsEnData),
      snippetGreetingUserTh: computed(() => this.snippetGreetingUserThData),
      snippetGreetingUserEn: computed(() => this.snippetGreetingUserEnData),

      // S14-P9 — FullV2 (full-screen widget) customization tokens, same reactive-provide pattern
      // as the S14-P3/P4 blocks above
      snippetFullGreetingTh: computed(() => this.snippetFullGreetingThData),
      snippetFullGreetingEn: computed(() => this.snippetFullGreetingEnData),
      snippetFullGreetingUserTh: computed(() => this.snippetFullGreetingUserThData),
      snippetFullGreetingUserEn: computed(() => this.snippetFullGreetingUserEnData),
      snippetFullWelcomeTaglineTh: computed(() => this.snippetFullWelcomeTaglineThData),
      snippetFullWelcomeTaglineEn: computed(() => this.snippetFullWelcomeTaglineEnData),
      snippetFullWelcomeSubtitle1Th: computed(() => this.snippetFullWelcomeSubtitle1ThData),
      snippetFullWelcomeSubtitle1En: computed(() => this.snippetFullWelcomeSubtitle1EnData),
      snippetFullWelcomeSubtitle2Th: computed(() => this.snippetFullWelcomeSubtitle2ThData),
      snippetFullWelcomeSubtitle2En: computed(() => this.snippetFullWelcomeSubtitle2EnData),
      snippetFullWelcomeBetaTh: computed(() => this.snippetFullWelcomeBetaThData),
      snippetFullWelcomeBetaEn: computed(() => this.snippetFullWelcomeBetaEnData),
      snippetFullQuickChipsTh: computed(() => this.snippetFullQuickChipsThData),
      snippetFullQuickChipsEn: computed(() => this.snippetFullQuickChipsEnData),
      snippetFullSuggestionKeywordsTh: computed(() => this.snippetFullSuggestionKeywordsThData),
      snippetFullSuggestionKeywordsEn: computed(() => this.snippetFullSuggestionKeywordsEnData),
      snippetFullChipColor: computed(() => this.snippetFullChipColorData),
      snippetFullShowLogin: computed(() => this.snippetFullShowLoginData),
      snippetFullShowTranslate: computed(() => this.snippetFullShowTranslateData),
      snippetFullShowHistory: computed(() => this.snippetFullShowHistoryData),
      snippetFullShowMic: computed(() => this.snippetFullShowMicData),
      snippetFullShowUpload: computed(() => this.snippetFullShowUploadData),
      // 🔄 AMENDMENT 2026-09-03 (S14-P9 AC14) — widget first-paint gate: false จน GetConfigThem settle
      snippetThemeResolved: computed(() => this.snippetThemeResolvedData),
    };
  },
  setup() {
    const store = useStore();

    return { store };
  },
  created() {
    // ต้องผูกก่อน configColor() เสมอ — loader ยิงธีมตั้งแต่ +0ms และจะ post ลงมาทันทีที่ FS2 ส่ง
    // NT_INIT_CHAT_READY ขึ้นไป ซึ่งอาจเกิดก่อนที่ router จะ resolve เสร็จ
    this.bindSnippetThemeRelay();
    this.syncSnippetStatusFromRoute();
    this.fetchLocalLoginFlag();
  },
  beforeUnmount() {
    if (this._snippetThemeHandler) {
      window.removeEventListener('message', this._snippetThemeHandler);
      this._snippetThemeHandler = null;
    }
  },
  components: {
    NavBar,
    BannerPopup,
    CookieConsentBanner,
  },
  watch: {
    '$route.fullPath'(newPath, oldPath) {
      this.syncSnippetStatusFromRoute();
      // SU-P17 — refresh localLogin flag on every navigation so a mid-session toggle change
      // (SuperAdmin เปลี่ยน EnableUsernamePasswordLogin ที่ CoreConfiguration) มีผลทันทีเมื่อเปลี่ยนหน้า
      // โดยไม่ต้อง full reload (created() ยิงครั้งเดียวตอน mount → ค่าจะ stale ถ้าไม่ refetch)
      //
      // ⚠ ข้าม fire แรกของทุก page load: main.js เรียก app.mount() โดยไม่ await router.isReady()
      // (main.js:56) → route จริง resolve "หลัง" created() เสมอ watcher จึงยิง 1 ครั้งทันทีทั้งที่ยัง
      // เป็นการโหลดหน้าเดียวกันกับที่ created() เพิ่งยิง CheckStatusSSO ไป = ซ้ำฟรี 1 request ทุกครั้ง
      // (วัดจาก HAR: ห่างกัน 134ms หลังอันแรกตอบกลับแล้ว in-flight guard จึงกันไม่ได้)
      // ใช้ oldPath === '/' เป็นตัวแยก: '/' คือ START_LOCATION ของ vue-router ก่อน resolve และในแอปนี้
      // '/' เป็น pure redirect ไป Login (router.js:49-53) ผู้ใช้จึงไม่มีทาง "อยู่" ที่ '/' จริง ๆ
      // — เคส navigate เข้า '/' เอง ก็ยิงไปแล้วหนึ่งครั้งตอน fire ของ X→'/'
      if (oldPath !== '/') {
        this.fetchLocalLoginFlag();
      }
      // เข้า /login ผ่าน SPA navigation (เช่น หลัง logout ที่ใช้ router.push('/login'))
      // App.vue ไม่ได้ remount จึงไม่ผ่าน mounted() ที่เรียก GetStartUpImage —
      // ต้องเรียกซ้ำเองเพื่อโหลด custom LoginLogo ของบริษัทและตั้ง flagNav = true
      // (ไม่งั้น skeleton ของ logo จะค้างเป็นกล่องเทา). เช็ก !flagNav กันยิงซ้ำเมื่อโหลดเสร็จแล้ว
      if ((this.$route.path || '').toLocaleLowerCase() === '/login' && !this.flagNav) {
        this.GetStartUpImage();
      }
      // ปิด global skeleton ทันทีที่ route เปลี่ยนไปถึง SuperAdminDashboard (ให้ skeleton ของ Dashboard เอง take over)
      // เลื่อนด้วย next tick เพื่อหลีกเลี่ยง flash ระหว่าง unmount/mount
      if (this.postLoginSkeleton) {
        const path = (this.$route.path || '').toLocaleLowerCase();
        if (path.startsWith('/superadmin')) {
          this.$nextTick(() => {
            // ให้ component ใหม่ mount และวาด skeleton ของตัวเองเสร็จก่อนค่อยปิดของ App.vue
            requestAnimationFrame(() => {
              this.postLoginSkeleton = false;
              if (this._postLoginSkeletonTimer) {
                clearTimeout(this._postLoginSkeletonTimer);
                this._postLoginSkeletonTimer = null;
              }
            });
          });
        }
      }
    },
  },
  computed: {
    // Portal admin + SuperAdmin → DGA orange (dgaTheme). Public/auth/chat shells (login, landing,
    // snippet, FullStream, register, error) keep the default light theme so their own identity is
    // untouched. White-label surfaces (navbar/chat colors, logos) come from per-company config via
    // inline styles in NavBar/App configColor — those override the theme, so they stay company-branded.
    appTheme() {
      const path = (this.$route.path || '').toLocaleLowerCase();
      const publicOrChatShell =
        !path ||
        path === '/' ||
        path === '/login' ||
        path === '/redirectfromlogin' ||
        path === '/loginsnippet' ||
        path === '/register' ||
        path === '/register-success' ||
        path === '/select-company' ||
        path === '/no-access' ||
        path === '/snippetunauthen' ||
        path === '/fullstream' ||
        path === '/fullstreamv2' ||
        path.startsWith('/landing') ||
        path.includes('snippet') ||
        path.includes('error');
      return publicOrChatShell ? 'light' : 'dgaTheme';
    },
    // Portal admin pages → light-gray page background (SuperAdmin look); content cards (DgaDataTable etc.)
    // sit white on the grey. Public/auth/chat shells keep white. (SuperAdmin routes render inside
    // SuperAdminLayout which paints its own #f5f7fa, so this is harmless there.)
    mainBgColor() {
      return this.appTheme === 'dgaTheme' ? '#f5f7fa' : '#ffffff';
    },
    ...mapState([
      'Snippet_StatusData',
      {
        isDrawerActuallyOpen: (state) => state.isDrawerOpen,
      },
    ]),
    isFullStreamReDesignRoute() {
      return this.$route.name === 'FullStream' || this.$route.name === 'FullStreamV2';
    },
    isPublicShellRoute() {
      return this.$route.name === 'Landing' || this.$route.name === 'LandingPrivacy' || this.$route.name === 'LandingTerms' || this.$route.name === 'LandingServices' || this.$route.name === 'LandingPartnership' || this.$route.name === 'LandingCookie' || this.$route.name === 'Maintenance';
    },
    isFlowCreatorRoute() {
      return this.$route.name === 'FlowCreator';
    },
    showAppNavBar() {
      // กัน NavBar แสดงระหว่าง redirect หลัง login สำเร็จ หรือเปิด tab ใหม่จาก FullStream snippet
      if (this.postLoginSkeleton || this.$route?.query?.saTransition === '1' || hasSuperAdminTransitionQuery()) return false;
      const path = (this.$route.path || '').toLocaleLowerCase();
      if (!path) return false;
      return (
        // '/' เป็น redirect route ไป /login — กัน NavBar mount + ยิง GetConsentConfig ระหว่าง redirect resolve
        path !== '/' &&
        path !== '/login' &&
        path !== '/redirectfromlogin' &&
        path !== '/loginsnippet' &&
        path !== '/register' &&
        path !== '/register-success' &&
        path !== '/select-company' &&
        path !== '/no-access' &&
        path !== '/snippetunauthen' &&
        path !== '/landing' &&
        path !== '/landing/privacy' &&
        path !== '/landing/partnership' &&
        path !== '/landing/services' &&
        path !== '/landing/terms' &&
        path !== '/landing/cookie' &&
        path !== '/maintenance' &&
        !path.startsWith('/superadmin') &&
        !path.includes('error') &&
        path !== '/fullstreamv2' &&
        path !== '/fullstream'
      );
    },
  },
  data() {
    return {
      isTextToImageModel: false,
      isAllowLLMChange: false,
      selectedLLMModel: null,
      FileUploadLimit: null,
      maximumChatInput: 20000,
      Region: import.meta.env.VITE_APP_Region,
      SubscriptionKey: import.meta.env.VITE_APP_SubscriptionKey,
      IsChainMassage: false,
      listTopicData: [], // [ { "topicID": 60, "topicName": "ABC", "status": false },]
      Flag_Click_Rename: false,
      Flag_Click_HistoryData: false,
      Loading_History_Status: false,

      Log_History_TakeData: 5,
      // Log_History_TopicID: null,
      Log_History_TopicIDData: -1,

      Log_History_IDData: null,

      KeyTopicData: null,
      // KeyTopic: "d332ccb2-b020-4373-a8de-8fe722651bec",

      TopicNameData: '',

      //TopicModelID : "1"

      TopicModelIDData: '',
      TopicModelID_longData: -1,
      StatusKeyRenameData: false,
      ModelFirstData: '-',
      firstModel: '-',
      isFeedback: false,
      auth_tokenData: null,

      ChatbotNameData: 'Chatbot',
      ChatbotIcon: null,
      FontColorTitle: null,
      colorThemeChat: null,
      NavbarBtnColorThemeData: null,
      NavbarTxtColorThemeData: null,
      isImgIconChatData: null,

      LoginLogo: null,
      IconChat: null,
      NavbarIcon: null,
      NavbarBackGround: null,
      SubNavbarBackGround: null,
      themeAssetUrls: {},
      // S14-P3 — per-company snippet customization tokens (from GetConfigThem), provided to
      // descendants (FullStreamReDesignV2.vue) via provide()/inject below
      snippetGreetingThData: '',
      snippetGreetingEnData: '',
      snippetChipColorData: '',
      snippetShowLoginData: null, // bool|null — null/true = show login (default), false = hide
      snippetShowTranslateData: null, // bool|null — null/true = show language switcher (default), false = hide
      snippetShowHistoryData: null, // bool|null — null/true = show history sidebar (default), false = hide
      snippetShowMicData: null, // bool|null — null/true = show mic / STT button in input box (default), false = hide
      // S14-P4 — per-company snippet welcome-text + quick-chip content tokens (from GetConfigThem),
      // provided to descendants (FullStreamReDesignV2.vue) via provide()/inject below. Hydrated
      // UNCONDITIONALLY here (same as the S14-P3 block above) — the snippetStatus content gate
      // lives in the CONSUMER's computeds, not here. See configColor() below + Tech Note #4.
      snippetWelcomeTaglineThData: '',
      snippetWelcomeTaglineEnData: '',
      snippetWelcomeSubtitle1ThData: '',
      snippetWelcomeSubtitle1EnData: '',
      snippetWelcomeSubtitle2ThData: '',
      snippetWelcomeSubtitle2EnData: '',
      snippetWelcomeBetaThData: '',
      snippetWelcomeBetaEnData: '',
      snippetQuickChipsThData: [],
      snippetQuickChipsEnData: [],
      snippetSuggestionKeywordsThData: [],
      snippetSuggestionKeywordsEnData: [],
      snippetGreetingUserThData: '',
      snippetGreetingUserEnData: '',
      // S14-P9 — FullV2 (full-screen widget) per-company customization tokens (from GetConfigThem),
      // provided to descendants (FullStreamReDesignV2.vue) via provide()/inject below. Hydrated
      // UNCONDITIONALLY (same rule as the S14-P3/P4 blocks above) — the snippetFullCustomizeActive
      // content gate lives in the CONSUMER's computeds, not here. See configColor() below.
      snippetFullGreetingThData: '',
      snippetFullGreetingEnData: '',
      snippetFullGreetingUserThData: '',
      snippetFullGreetingUserEnData: '',
      snippetFullWelcomeTaglineThData: '',
      snippetFullWelcomeTaglineEnData: '',
      snippetFullWelcomeSubtitle1ThData: '',
      snippetFullWelcomeSubtitle1EnData: '',
      snippetFullWelcomeSubtitle2ThData: '',
      snippetFullWelcomeSubtitle2EnData: '',
      snippetFullWelcomeBetaThData: '',
      snippetFullWelcomeBetaEnData: '',
      snippetFullQuickChipsThData: [],
      snippetFullQuickChipsEnData: [],
      snippetFullSuggestionKeywordsThData: [],
      snippetFullSuggestionKeywordsEnData: [],
      snippetFullChipColorData: '',
      snippetFullShowLoginData: null, // bool|null — null/true = show login (default), false = hide
      snippetFullShowTranslateData: null, // bool|null — null/true = show language switcher (default), false = hide
      snippetFullShowHistoryData: null, // bool|null — null/true = show history sidebar (default), false = hide
      snippetFullShowMicData: null, // bool|null — null/true = show mic / STT button in input box (default), false = hide
      snippetFullShowUploadData: null, // bool|null — null/true = show upload button (default), false = hide
      // 🔄 AMENDMENT 2026-09-03 (S14-P9 AC14) — one-way latch: false → true ครั้งเดียว ห้าม set กลับ false
      snippetThemeResolvedData: false,
      IsAllowImage: false,
      flagNav: false,
      lastLLMID: null,
      countff: 0,
      // headerTitle: "@/assets/images/Rectangle 51.png",
      // headerCover: "@/assets/images/Rectangle 51.png",
      // headerC: "@/assets/images/Rectangle 51.png",
      parameterURL: [],
      tabSocialTypeData: [
        { text: 'All', value: 'All', unreadCount: 0 },
        { text: 'Facebook', value: 'Facebook', unreadCount: 0 },
        { text: 'Line', value: 'Line', unreadCount: 0 },
        { text: 'Instagram', value: 'Instagram', unreadCount: 0 },
      ],
      unreadCountData: 0,
      Status_ErrorData: false,
      Snippet_UsernameData: '',
      Snippet_StatusData: false,
      snippetLocaleApplied: false, // S14-P4 follow-up: apply snippet default language once, on the initial snippet load
      snippetFullLocaleApplied: false, // S14-P9: apply FullV2 (full=true) default language once, on the initial FullV2 load — own flag, separate gate from the small side above
      User_Id_ShowData: '',
      User_IdData: '',
      User_Id_Status: false,
      Time_DelayData: 0,
      flagShowTopicData: true,
      LeftNavBarData: true,
      SetPopupData: false,
      flagGetAllTopicData: false,
      miniVariantData: false,
      username: null,
      roleId: null,
      // Global skeleton overlay เพื่อกัน flash NavBar / page อื่นระหว่าง redirect หลัง login สำเร็จ หรือเปิด tab ใหม่จาก snippet
      postLoginSkeleton: typeof window !== 'undefined' && (sessionStorage.getItem('_fusion_sa_navigating_from_login') === '1' || hasSuperAdminTransitionQuery()),
      _postLoginSkeletonTimer: null,
    };
  },
  methods: {
    isTruthyQueryParam(value) {
      if (typeof value === 'boolean') {
        return value;
      }

      if (typeof value === 'string') {
        return value.toLowerCase() === 'true';
      }

      return Boolean(value);
    },
    getSnippetStatusFromRoute() {
      const routeName = this.$route?.name || '';
      const routePath = (this.$route?.path || '').toLocaleLowerCase();
      const routeQuery = this.$route?.query || {};

      if (routeName === 'FullStream' || routeName === 'FullStreamV2' || routePath === '/fullstream' || routePath === '/fullstreamv2') {
        return this.isTruthyQueryParam(routeQuery.snippet);
      }

      if (routeName === 'Snippet' || routePath === '/snippet') {
        return !this.isTruthyQueryParam(routeQuery.flagnavbar);
      }

      if (routeName === 'SnippetUnauthen' || routePath === '/snippetunauthen') {
        return true;
      }

      return false;
    },
    // snippet customization (หน้า /SnippetCustomization) มีผลเฉพาะ widget ตัวเล็ก
    // (ChatFrameworkSnippetSmallV2.js → full=false) — FullV2 ก็ส่ง snippet=true เหมือนกัน
    // แต่มากับ full=true จึงต้องไม่ apply (เช่น snippetDefaultLanguage ใน configColor)
    getSnippetCustomizeStatusFromRoute() {
      if (!this.getSnippetStatusFromRoute()) return false;
      const routeQuery = this.$route?.query || {};
      return !this.isTruthyQueryParam(routeQuery.full);
    },
    // S14-P9 — FullV2 customization (หน้า /SnippetFullCustomization) มีผลเฉพาะ widget เต็มจอ
    // (ChatFrameworkSnippetFullV2.js → full=true) — กระจกกลับด้านของ method ข้างบน
    getSnippetFullCustomizeStatusFromRoute() {
      if (!this.getSnippetStatusFromRoute()) return false;
      const routeQuery = this.$route?.query || {};
      return this.isTruthyQueryParam(routeQuery.full);
    },
    syncSnippetStatusFromRoute() {
      const snippetStatus = this.getSnippetStatusFromRoute();

      this.store.commit('setSnippetStatus', snippetStatus);
      this.Snippet_StatusData = snippetStatus;
    },
    // SU-P17 — Credential Visibility Gating: fetch localLogin flag once at app init so every
    // view can read the single Vuex getter `localLoginEnabled` instead of each hitting the API.
    //
    // 2026-08-13 — เก็บ response ทั้งก้อนลง store ด้วย ไม่ใช่แค่ localLogin: response ของ {key:'SSO'}
    // มี provider flag (microsoft/authentik/thaiID/dgaDigitalID) ติดมาครบอยู่แล้ว ซึ่งเดิม Login.vue
    // ยิง request เดิมซ้ำอีกรอบเพื่อเอาไปใช้ (App.vue + Login.vue = 2 request เหมือนกันเป๊ะบนหน้า /login)
    fetchLocalLoginFlag() {
      // ข้ามทั้งหมดเมื่ออยู่บน surface ของ snippet: ผู้ใช้ getter `localLoginEnabled` ทุกตัวเป็นหน้า
      // พอร์ทัล (UserManagement, UserProfile, UserChatManagement, superadmin/*) ซึ่งไม่มีตัวไหน
      // mount ในiframe ของ widget เลย — ยิงไปก็ไม่มีใครอ่าน เสียฟรีทุกครั้งที่มีคนเปิดหน้าเว็บลูกค้า
      // ใช้ window.location แทน $route เพราะ created() ทำงานก่อน router resolve เสร็จ (route ยังเป็น
      // START_LOCATION '/') — history mode เป็น createWebHistory ค่านี้จึงเป็น path จริงเสมอ
      const path = (window.location?.pathname || '').toLocaleLowerCase();
      if (path.match('snippet') || path.match('fullstream')) return;

      this.$call.CheckStatusSSO(
        { key: 'SSO' },
        (res) => {
          this.$store.commit('SET_LOCAL_LOGIN_FLAG', res?.data?.localLogin === true);
          this.$store.commit('SET_SSO_STATUS', res?.data || {});
        },
        () => {
          this.$store.commit('SET_LOCAL_LOGIN_FLAG', false);
          // {} = "ยิงแล้วแต่ล้มเหลว" — ต่างจาก null (ยังไม่ทราบ) เพื่อให้ Login.vue รู้ว่าต้อง fallback
          this.$store.commit('SET_SSO_STATUS', {});
        }
      );
    },
    SetStatusKeyRename(stat) {
      var that = this;
      that.StatusKeyRename = stat;
    },
    keyupKeyRename() {
      var that = this;

      if (event.key != 'Enter') {
        that.StatusKeyRenameData = true;
      }
    },
    clearInfo() {
      var that = this;
      that.listTopicData = [];
      that.TopicNameData = '';
      that.TopicModelIDData = '';
      that.TopicModelID_longData = '';
      that.ModelFirstData = '-';

      that.KeyTopicData = null;
      that.Log_History_TopicIDData = -1;
      that.Log_History_IDData = null;
      that.Flag_Click_Rename = false;
      that.Flag_Click_HistoryData = false;
      that.Loading_History_Status = false;
      that.isFeedback = false;
      that.Log_History_TakeData = 5;
    },
    Click_History_List(_Log_History_TopicID, _TopicName, _TopicModelID, _topicModelID_long, _keyTopic) {
      var that = this;
      that.Log_History_TopicIDData = _Log_History_TopicID;
      that.Log_History_IDData = null;

      that.Flag_Click_HistoryData = !that.Flag_Click_HistoryData;
      that.TopicNameData = _TopicName;

      that.TopicModelIDData = _TopicModelID;
      that.TopicModelID_longData = _topicModelID_long;

      that.ModelFirstData = _TopicModelID;
      // that.ChatbotNameData = _TopicModelID.includes('(') ? _TopicModelID.split('(')[1].split(')')[0] : _TopicModelID;
      that.KeyTopicData = _keyTopic;

      if (_Log_History_TopicID == -1) {
        if (that.listTopicData != null && that.listTopicData.length > 0) {
          if (that.listTopicData[0].topicID != -1) {
            // that.listTopic = [{ "topicID": _Log_History_TopicID, "topicName": "...", "keyTopic": "", "status": false ,"TopicModelID":"1"}].concat(that.listTopic);

            that.listTopicData = [
              {
                topicID: _Log_History_TopicID,
                topicName: _TopicName,
                keyTopic: '',
                status: false,
                topicModelID_long: _topicModelID_long,
                topicModelID: _TopicModelID,
              },
            ].concat(that.listTopicData);
          } else {
            that.listTopicData = that.listTopicData.slice(1, that.listTopicData.length);

            that.listTopicData = [
              {
                topicID: _Log_History_TopicID,
                topicName: _TopicName,
                keyTopic: '',
                status: false,
                topicModelID_long: _topicModelID_long,
                topicModelID: _TopicModelID,
              },
            ].concat(that.listTopicData);
          }
        } else {
          // that.listTopic = [{ "topicID": _Log_History_TopicID, "topicName": "...", "keyTopic": "", "status": false  ,"TopicModelID":"1"}];
          that.listTopicData = [
            {
              topicID: _Log_History_TopicID,
              topicName: _TopicName,
              keyTopic: '',
              status: false,
              topicModelID_long: _topicModelID_long,
              topicModelID: _TopicModelID,
            },
          ];
        }
      }
    },
    RenameClick(iTopic, TopicId) {
      var that = this;
      iTopic.status = true;
      that.StatusKeyRenameData = false;

      //(iTopic.TopicRef != null ? : fa)

      var _TopicId = document.getElementById(TopicId);
      if (_TopicId != undefined && _TopicId != null) {
        // _TopicId
        that.$nextTick(() => {
          _TopicId.focus();
        });
      }
    },

    GetUuidv4_Fun() {
      let Uuid = '10000000-1000-4000-8000-100000000000'.replace(/[018]/g, (c) => (c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16));

      return Uuid;
    },
    RenameTopicStream(_TopicID, _KeyTopic, _topicName, index, tempAuth_token) {
      var that = this;
      try {
        // if (that.StatusKeyRenameData == false) {

        //   return;
        // }

        if (_KeyTopic == null || _KeyTopic == '' || _TopicID == -1) {
          _KeyTopic = that.GetUuidv4_Fun();
        }
        if (_TopicID == -1) {
          _KeyTopic = that.GetUuidv4_Fun();
        }

        that.StatusKeyRenameData = false;
        let _Data = {
          TopicID: _TopicID == null ? -1 : _TopicID,
          TopicName: _topicName,
          USER_CHANNEL: that.User_IdData,
          KeyTopic: _KeyTopic,
        };

        that.$call.RenameTopicStream(
          _Data,
          tempAuth_token,
          (response) => {
            if (response.status == 0) {
              if (_TopicID == -1) {
                that.listTopicData[index].topicID = response.data;

                that.Log_History_TopicIDData = response.data;
                that.TopicNameData = _topicName;
              }

              if (that.Log_History_TopicIDData == _TopicID) {
                that.TopicNameData = _topicName;
              }

              that.Flag_Click_HistoryData = !that.Flag_Click_HistoryData;
              // that.Flag_Click_Rename = !that.Flag_Click_Rename;

              console.log('RenameTopicStream OK');
            } else {
              if (response.message == 'Token has expired!!!') {
                that.NotificationTokenExpired();
              } else {
                Swal.fire({
                  title: 'เกิดข้อผิดพลาด',
                  text: response.message,
                  showConfirmButton: false,
                  timer: 1500,
                });
              }
            }
          },
          () => {
            Swal.fire({
              title: 'เกิดข้อผิดพลาด',
              text: '',
              showConfirmButton: false,
              timer: 1500,
            });
          }
        );
      } catch {
        Swal.fire({
          title: 'เกิดข้อผิดพลาด',
          text: '',
          showConfirmButton: false,
          timer: 1500,
        });
      }
    },
    DeleteTopicStream(_TopicID, _KeyTopic, _indexTopic) {
      var that = this;

      try {
        let _User_Id = {
          TopicID: _TopicID,
          KeyTopic: _KeyTopic,
          USER_CHANNEL: that.User_IdData,
        };

        if (_TopicID != -1) {
          that.$call.DeleteTopicStream(
            _User_Id,
            (response) => {
              if (response.status == 0) {
                that.listTopicData.splice(_indexTopic, 1);

                if (_User_Id.TopicID == that.Log_History_TopicIDData) {
                  if (that.listTopicData.length > 0) {
                    if (that.listTopicData.length > _indexTopic - 1 && _indexTopic - 1 > 0) {
                      that.TopicNameData = that.listTopicData[_indexTopic - 1].topicName;

                      that.Log_History_TopicIDData = that.listTopicData[_indexTopic - 1].topicID;
                      that.Log_History_IDData = null;
                      that.Flag_Click_HistoryData = !that.Flag_Click_HistoryData;
                    } else {
                      that.TopicNameData = that.listTopicData[0].topicName;

                      that.Log_History_TopicIDData = that.listTopicData[0].topicID;

                      that.Log_History_IDData = null;
                      that.Flag_Click_HistoryData = !that.Flag_Click_HistoryData;
                    }
                  } else {
                    that.TopicNameData = '';
                    ((that.Log_History_TopicIDData = -1), (that.Log_History_IDData = null));
                    that.Flag_Click_HistoryData = !that.Flag_Click_HistoryData;
                  }
                }
              } else {
                Swal.fire({
                  title: 'เกิดข้อผิดพลาด',
                  text: response.message,
                  showConfirmButton: false,
                  timer: 1500,
                });
              }
            },
            () => {
              Swal.fire({
                title: 'เกิดข้อผิดพลาด',
                text: '',
                showConfirmButton: false,
                timer: 1500,
              });
            }
          );
        } else {
          that.listTopicData.splice(_indexTopic, 1);
        }
      } catch {
        Swal.fire({
          title: 'เกิดข้อผิดพลาด',
          text: '',
          showConfirmButton: false,
          timer: 1500,
        });
      }
    },

    GetModelFirst(_groupmodel, _userID) {
      var that = this;
      let domainName = null;
      let tokenParam = null;
      let ModelDisplayID = null;
      try {
        if (sessionStorage.getItem('Domain') != undefined && sessionStorage.getItem('Domain') != null) {
          domainName = sessionStorage.getItem('Domain');
        } else {
          if (that.parameterURL != null && that.parameterURL != []) {
            if (that.parameterURL.domainname != undefined) {
              domainName = that.parameterURL.domainname;
            } else if (sessionStorage.getItem('Domain') != undefined && sessionStorage.getItem('Domain') != null) {
              domainName = sessionStorage.getItem('Domain');
            }
          }
        }
        if (sessionStorage.getItem('tokenParam') != undefined && sessionStorage.getItem('tokenParam') != null) {
          tokenParam = sessionStorage.getItem('tokenParam');
        } else {
          if (that.parameterURL != null && that.parameterURL != []) {
            if (that.parameterURL.tokenParam != undefined) {
              ModelDisplayID = that.parameterURL.tokenParam;
            } else if (sessionStorage.getItem('tokenParam') != undefined && sessionStorage.getItem('tokenParam') != null) {
              ModelDisplayID = sessionStorage.getItem('tokenParam');
            }
          }
        }
        if (sessionStorage.getItem('modelID') != undefined && sessionStorage.getItem('modelID') != null) {
          ModelDisplayID = sessionStorage.getItem('modelID');
        } else {
          if (that.parameterURL != null && that.parameterURL != []) {
            if (that.parameterURL.modelid != undefined) {
              ModelDisplayID = that.parameterURL.modelid;
            } else if (sessionStorage.getItem('modelID') != undefined && sessionStorage.getItem('modelID') != null) {
              ModelDisplayID = sessionStorage.getItem('modelID');
            }
          }
        }
        let _Data = {
          groupModel: _groupmodel,
          UserSend: _userID ?? that.User_IdData,
          DomainName: domainName,
          TokenParam: tokenParam,
          ModelDisplayID: ModelDisplayID,
        };
        if (that.Log_History_TopicIDData != -1) {
          return;
        }
        that.$call.GetModelFirst(
          _Data,
          (response) => {
            if (response.status == 0) {
              that.ModelFirstData = that.ModelFirstData == '-' ? response.data.modelDisplayID + ' (' + response.data.modelName + ')' : that.ModelFirstData;
              this.firstModel = response.data.modelDisplayID + ' (' + response.data.modelName + ')';
              that.TopicModelIDData = that.ModelFirstData;
              that.isAllowLLMChange = response.data.isAllowLLMChange;
              that.Time_DelayData = response.data.timeDelay;
              that.maximumChatInput = response.data.maximumChatInput;
            } else {
              that.ModelFirstData = '-';
              this.firstModel = '-';
              that.TopicModelIDData = that.ModelFirstData;
            }
          },
          () => {
            that.ModelFirstData = '-';
            this.firstModel = '-';
            that.TopicModelIDData = that.ModelFirstData;
          }
        );
      } catch (e) {
        that.ModelFirstData = '-';
        this.firstModel = '-';
        that.TopicModelIDData = that.ModelFirstData;
      }
    },
    GetModelFirst_Value(_groupmodel, _userID) {
      var that = this;
      try {
        let _Data = {
          groupModel: _groupmodel,
          UserSend: _userID ?? that.User_IdData,
        };
        if (that.Log_History_TopicIDData != -1) {
          return;
        }
        that.$call.GetModelFirst(
          _Data,
          (response) => {
            if (response.status == 0) {
              that.ModelFirstData = that.ModelFirstData == '-' ? response.data.modelDisplayID + ' (' + response.data.modelName + ')' : that.ModelFirstData;
              this.firstModel = response.data.modelDisplayID + ' (' + response.data.modelName + ')';
              that.isAllowLLMChange = response.data.isAllowLLMChange;
              that.Time_DelayData = response.data.timeDelay;
              that.maximumChatInput = response.data.maximumChatInput;
            } else {
              that.ModelFirstData = '-';
              this.firstModel = '-';
            }
          },
          () => {
            that.ModelFirstData = '-';
            this.firstModel = '-';
          }
        );
      } catch (e) {
        that.ModelFirstData = '-';
        this.firstModel = '-';
      }
    },
    // ===== Snippet theme relay (2026-08-13) =====
    // widget = 2 document: loader อยู่บนหน้าลูกค้า, Vue app อยู่ในiframe (คนละ origin ⇒ อ่านตัวแปร
    // ข้ามกันไม่ได้ ต้อง postMessage อย่างเดียว) เดิมต่างคนต่างยิง GetConfigThem = 2 request ต่อ
    // 1 page view ทั้งที่ payload ก้อนเดียวกัน (companyId เดียวกัน เพราะ loader เป็นคนประกอบ iframe src)
    // ตอนนี้ loader ส่ง payload ที่ตัวเองยิงได้ลงมาให้ → ฝั่งนี้ไม่ต้องยิงซ้ำ
    bindSnippetThemeRelay() {
      this._snippetThemeSettled = false;
      this._snippetThemePayload = null;
      this._snippetThemeWaiters = [];
      // ไม่ได้อยู่ในiframe = เปิด /FullStreamV2 ตรง ๆ ไม่มี loader คอยส่งให้ → ต้องยิงเอง
      if (typeof window === 'undefined' || window.parent === window) return;
      this._snippetThemeHandler = (event) => {
        // รับจาก embedder เท่านั้น (เทียบ window object ไม่ใช่ origin string เพราะ origin ของหน้าแม่
        // คือโดเมนลูกค้าซึ่งเป็นอะไรก็ได้ — ตรวจแบบนี้กันเฟรม/แท็บอื่นยัดธีมปลอมเข้ามา)
        if (event.source !== window.parent) return;
        const msg = event.data;
        if (!msg || typeof msg !== 'object' || msg.type !== 'NT_SNIPPET_THEME') return;
        this.resolveSnippetThemeRelay(msg.data || null);
      };
      window.addEventListener('message', this._snippetThemeHandler);
    },
    resolveSnippetThemeRelay(payload) {
      if (this._snippetThemeSettled) return;
      this._snippetThemeSettled = true;
      this._snippetThemePayload = payload;
      const waiters = this._snippetThemeWaiters || [];
      this._snippetThemeWaiters = [];
      waiters.forEach((fn) => fn(payload));
    },
    // คืน payload จาก loader ถ้ามาทัน มิฉะนั้นคืน null ให้ caller ไป fetch เอง (loader เวอร์ชันเก่าที่
    // ลูกค้า cache ไว้จะไม่ส่งอะไรมาเลย — เคสนี้ต้องไม่ค้าง จึงต้องมี timeout เสมอ)
    waitForRelayedSnippetTheme(timeoutMs = SNIPPET_THEME_RELAY_TIMEOUT_MS) {
      if (this._snippetThemeSettled) return Promise.resolve(this._snippetThemePayload);
      if (!this._snippetThemeHandler) return Promise.resolve(null);
      return new Promise((resolve) => {
        let done = (payload) => {
          done = () => {};
          clearTimeout(timer);
          resolve(payload);
        };
        const timer = setTimeout(() => done(null), timeoutMs);
        this._snippetThemeWaiters.push((payload) => done(payload));
      });
    },
    // 🔄 AMENDMENT 2026-09-03 (S14-P9 AC14) — mark theme settled (idempotent, เรียกซ้ำได้ทุก path)
    markSnippetThemeResolved() {
      if (this._snippetThemeHangTimer) {
        clearTimeout(this._snippetThemeHangTimer);
        this._snippetThemeHangTimer = null;
      }
      this.snippetThemeResolvedData = true;
    },
    configColor() {
      let self = this;
      return new Promise((resolve) => {
        // S14-P3 — thread companyId from the route query in snippet/fullstream mode so an
        // anonymous widget user resolves THEIR company's theme instead of falling through to the
        // global theme (bug: previously called with no companyId at all — Tech Review Notes #3).
        // Portal mode omits companyId — GetConfigThem falls back to the cookie-resolved company
        // exactly as before (backward compatible). Reuses the same path-matching convention as
        // GetStartUpImage()/countThemeImageLoad() above for detecting snippet/fullstream context.
        const routePath = (self.$route?.path || '').toLocaleLowerCase();
        const isSnippetOrFullstreamMode = !!(routePath.match('snippet') || routePath.match('fullstream'));
        const routeQuery = self.$route?.query || {};
        const companyId = isSnippetOrFullstreamMode ? routeQuery.companyId ?? routeQuery.companyid : undefined;
        // S14-P9 — FullV2 loader (full=true) never posts NT_SNIPPET_THEME (only SmallV2's does)
        // → waiting 2.5s here is a guaranteed timeout. Skip straight to GetConfigThem.
        const isFullWidget = self.isTruthyQueryParam(routeQuery.full);

        // 🔄 AMENDMENT 2026-09-03 (S14-P9 AC14) — arm hang-timer เฉพาะ widget mode (snippet=true ทั้ง full=true/false)
        // ใช้ getSnippetStatusFromRoute() ไม่ใช่ isSnippetOrFullstreamMode: /FullStreamV2 แบบ portal (ไม่มี snippet=true)
        // ก็ match 'fullstream' เหมือนกัน — TC-24 ห้าม arm ในโหมด portal (clear-before-arm กัน timer ซ้อนเชิง defensive)
        if (self.getSnippetStatusFromRoute() && !self.snippetThemeResolvedData) {
          if (self._snippetThemeHangTimer) clearTimeout(self._snippetThemeHangTimer);
          self._snippetThemeHangTimer = setTimeout(() => {
            self._snippetThemeHangTimer = null;
            self.markSnippetThemeResolved();
          }, SNIPPET_THEME_HANG_TIMEOUT_MS);
        }

        const applyThemeResponse = async (response) => {
          let data = response.data;

          if (response.status == 0 && response.message != 'Posted invalid data.') {
            self.ChatbotNameData = data.nameChat;
            self.ChatbotIcon = data.iconChat;

            self.FontColorTitle = data.fontColorTitle;
            this.colorThemeChat = data.colorThemeChat;
            self.NavbarBtnColorThemeData = data.navbarButton;
            self.NavbarTxtColorThemeData = data.navbarColorText;
            self.isImgIconChatData = data.isImgIconChat;
            self.themeAssetUrls = {
              ...(data.assetUrls || {}),
              LoginLogo: data.loginLogoUrl || data.assetUrls?.LoginLogo,
              ChatIcon: data.chatIconUrl || data.assetUrls?.ChatIcon,
              NavLogo: data.navbarIconUrl || data.assetUrls?.NavLogo,
              NavBG: data.navbarBackGroundUrl || data.assetUrls?.NavBG,
              SubBG: data.subNavbarBackGroundUrl || data.assetUrls?.SubBG,
            };

            // S14-P3 — snippet customization tokens (per-company), null-safe (null/"" → keep
            // component defaults so descendants fall back to their own i18n/CSS default)
            self.snippetGreetingThData = data.snippetGreetingTh || '';
            self.snippetGreetingEnData = data.snippetGreetingEn || '';
            self.snippetChipColorData = data.snippetChipColor || '';
            self.snippetShowLoginData = data.snippetShowLogin ?? null;
            self.snippetShowTranslateData = data.snippetShowTranslate ?? null;
            self.snippetShowHistoryData = data.snippetShowHistory ?? null;
            self.snippetShowMicData = data.snippetShowMic ?? null;

            // S14-P4 — welcome text: '' when unset so the view falls back to its own $t(). Hydrated
            // unconditionally (this runs for portal too — that is correct; the content gate is in
            // FullStreamReDesignV2.vue's computeds, NOT here — see Tech Note #4).
            self.snippetWelcomeTaglineThData = data.snippetWelcomeTaglineTh || '';
            self.snippetWelcomeTaglineEnData = data.snippetWelcomeTaglineEn || '';
            self.snippetWelcomeSubtitle1ThData = data.snippetWelcomeSubtitle1Th || '';
            self.snippetWelcomeSubtitle1EnData = data.snippetWelcomeSubtitle1En || '';
            self.snippetWelcomeSubtitle2ThData = data.snippetWelcomeSubtitle2Th || '';
            self.snippetWelcomeSubtitle2EnData = data.snippetWelcomeSubtitle2En || '';
            self.snippetWelcomeBetaThData = data.snippetWelcomeBetaTh || '';
            self.snippetWelcomeBetaEnData = data.snippetWelcomeBetaEn || '';
            // S14-P4 — chips: always an array (API contract returns [] when unset)
            self.snippetQuickChipsThData = Array.isArray(data.snippetQuickChipsTh) ? data.snippetQuickChipsTh : [];
            self.snippetQuickChipsEnData = Array.isArray(data.snippetQuickChipsEn) ? data.snippetQuickChipsEn : [];
            self.snippetSuggestionKeywordsThData = Array.isArray(data.snippetSuggestionKeywordsTh) ? data.snippetSuggestionKeywordsTh : [];
            self.snippetSuggestionKeywordsEnData = Array.isArray(data.snippetSuggestionKeywordsEn) ? data.snippetSuggestionKeywordsEn : [];
            self.snippetGreetingUserThData = data.snippetGreetingUserTh || '';
            self.snippetGreetingUserEnData = data.snippetGreetingUserEn || '';

            // S14-P9 — FullV2 (full-screen widget) tokens: hydrated unconditionally, same rule as the
            // S14-P4 block above — the snippetFullCustomizeActive content gate lives in the CONSUMER
            // (FullStreamReDesignV2.vue) computeds, not here. snippetFullDefaultLanguage is NOT stored
            // (used once in the locale gate below, mirroring the small side).
            self.snippetFullGreetingThData = data.snippetFullGreetingTh || '';
            self.snippetFullGreetingEnData = data.snippetFullGreetingEn || '';
            self.snippetFullGreetingUserThData = data.snippetFullGreetingUserTh || '';
            self.snippetFullGreetingUserEnData = data.snippetFullGreetingUserEn || '';
            self.snippetFullWelcomeTaglineThData = data.snippetFullWelcomeTaglineTh || '';
            self.snippetFullWelcomeTaglineEnData = data.snippetFullWelcomeTaglineEn || '';
            self.snippetFullWelcomeSubtitle1ThData = data.snippetFullWelcomeSubtitle1Th || '';
            self.snippetFullWelcomeSubtitle1EnData = data.snippetFullWelcomeSubtitle1En || '';
            self.snippetFullWelcomeSubtitle2ThData = data.snippetFullWelcomeSubtitle2Th || '';
            self.snippetFullWelcomeSubtitle2EnData = data.snippetFullWelcomeSubtitle2En || '';
            self.snippetFullWelcomeBetaThData = data.snippetFullWelcomeBetaTh || '';
            self.snippetFullWelcomeBetaEnData = data.snippetFullWelcomeBetaEn || '';
            self.snippetFullQuickChipsThData = Array.isArray(data.snippetFullQuickChipsTh) ? data.snippetFullQuickChipsTh : [];
            self.snippetFullQuickChipsEnData = Array.isArray(data.snippetFullQuickChipsEn) ? data.snippetFullQuickChipsEn : [];
            self.snippetFullSuggestionKeywordsThData = Array.isArray(data.snippetFullSuggestionKeywordsTh) ? data.snippetFullSuggestionKeywordsTh : [];
            self.snippetFullSuggestionKeywordsEnData = Array.isArray(data.snippetFullSuggestionKeywordsEn) ? data.snippetFullSuggestionKeywordsEn : [];
            self.snippetFullChipColorData = data.snippetFullChipColor || '';
            self.snippetFullShowLoginData = data.snippetFullShowLogin ?? null;
            self.snippetFullShowTranslateData = data.snippetFullShowTranslate ?? null;
            self.snippetFullShowHistoryData = data.snippetFullShowHistory ?? null;
            self.snippetFullShowMicData = data.snippetFullShowMic ?? null;
            self.snippetFullShowUploadData = data.snippetFullShowUpload ?? null;

            // S14-P4 (follow-up) — snippet default language: on a SMALL-snippet load only (same
            // small-only rule as the content gates in FullStreamReDesignV2), set the widget's initial
            // locale once. Portal loads AND the FullV2 widget (full=true) never apply it; the flag
            // stops a later configColor() (route change) from overriding a user's manual toggle.
            const snippetDefaultLanguage = data.snippetDefaultLanguage;
            if (!self.snippetLocaleApplied && self.getSnippetCustomizeStatusFromRoute() &&
                (snippetDefaultLanguage === 'th' || snippetDefaultLanguage === 'en')) {
              self.$i18n.locale = snippetDefaultLanguage;
              self.snippetLocaleApplied = true;
            }

            // S14-P9 — FullV2 (full=true) default language: mirror of the small gate above, own flag.
            // The two gates are mutually exclusive by construction (full=true vs !full) — no locale race.
            const snippetFullDefaultLanguage = data.snippetFullDefaultLanguage;
            if (!self.snippetFullLocaleApplied && self.getSnippetFullCustomizeStatusFromRoute() &&
                (snippetFullDefaultLanguage === 'th' || snippetFullDefaultLanguage === 'en')) {
              self.$i18n.locale = snippetFullDefaultLanguage;
              self.snippetFullLocaleApplied = true;
            }
          }
          // 🔄 AMENDMENT 2026-09-03 (S14-P9 AC14) — settle ทุก branch (status 0 / non-0 / relay-applied)
          self.markSnippetThemeResolved();
          resolve(data);
        };

        // โหมด snippet: รอ payload จาก loader ก่อน (มันยิงไปตั้งแต่ +0ms ส่วนจุดนี้ทำงานราว +1.4s
        // จึงมาถึงก่อนแล้วแทบทุกครั้ง) — ได้มาก็ใช้เลยโดยไม่ต้องยิงซ้ำ, ไม่มาภายใน timeout ก็ยิงเอง
        // ตามเดิม (loader เวอร์ชันเก่า / fetch ฝั่ง loader ล้มเหลว / เปิด iframe จากที่อื่น)
        // รอเฉพาะเมื่ออยู่ใน iframe จริง — /FullStreamV2 แบบ top-level (portal หรือหน้าเด้งกลับจาก
        // consent/SSO ที่ query หาย) ไม่มี loader ให้รอ ยิง fetch เองทันทีไม่ต้องเสีย 2.5s ฟรี
        // S14-P9 — ยกเว้น full=true (FullV2) เสมอ: loader ตัวนี้ไม่เคย post NT_SNIPPET_THEME เลย
        // (มีแต่ SmallV2 ที่ post) ดังนั้นรอที่นี่ = timeout 2.5s ฟรีทุกครั้ง ข้ามไปยิง GetConfigThem ทันที
        if (isSnippetOrFullstreamMode && window.parent !== window && !isFullWidget) {
          self.waitForRelayedSnippetTheme().then((relayed) => {
            if (relayed) {
              // ห่อให้เป็นรูปเดียวกับ ResponseModel ที่ callback ของ $call ได้รับ
              applyThemeResponse({ status: 0, message: 'Successfully', data: relayed });
              return;
            }
            // 🔄 AMENDMENT 2026-09-03 (S14-P9 AC14) — error ปกติ reveal ทันที (relay-fallback path)
            self.$call.GetConfigThem(companyId, applyThemeResponse, () => { self.markSnippetThemeResolved(); resolve(null); });
          });
          return;
        }

        // 🔄 AMENDMENT 2026-09-03 (S14-P9 AC14) — error ปกติ reveal ทันที (direct path)
        self.$call.GetConfigThem(companyId, applyThemeResponse, () => { self.markSnippetThemeResolved(); resolve(null); });
      });
    },
    countThemeImageLoad() {
      this.countff++;
      if (!this.$route.path.toLocaleLowerCase().match('snippet') && !this.$route.path.toLocaleLowerCase().match('fullstream')) {
        this.flagNav = this.countff >= 5;
      } else if (this.$route.path.toLocaleLowerCase().match('fullstream')) {
        this.flagNav = this.countff >= 2;
      }
    },
    getThemeAssetUrl(filename) {
      const keyMap = {
        'LoginLogo.png': 'LoginLogo',
        'ChatIcon.png': 'ChatIcon',
        'NavLogo.png': 'NavLogo',
        'NavBG.png': 'NavBG',
        'SubBG.png': 'SubBG',
      };
      const key = keyMap[filename];
      return key ? this.themeAssetUrls?.[key] || null : null;
    },
    async GetStartUpImage() {
      let self = this;
      await self.configColor();
      if (!self.$route.path.toLocaleLowerCase().match('snippet') && !self.$route.path.toLocaleLowerCase().match('fullstream')) {
        const imagePromises = [self.getIMG('LoginLogo.png'), self.getIMG('ChatIcon.png'), self.getIMG('NavLogo.png'), self.getIMG('NavBG.png'), self.getIMG('SubBG.png')];

        const [LoginLogo, IconChat, NavbarIcon, NavbarBackGround, SubNavbarBackGround] = await Promise.all(imagePromises);

        if (LoginLogo || IconChat || NavbarIcon || NavbarBackGround || SubNavbarBackGround) {
          self.LoginLogo = LoginLogo || self.LoginLogo;
          self.IconChat = IconChat || self.IconChat;
          self.NavbarIcon = NavbarIcon || self.NavbarIcon;
          self.NavbarBackGround = NavbarBackGround || self.NavbarBackGround;
          self.SubNavbarBackGround = SubNavbarBackGround || self.SubNavbarBackGround;
          // console.log("NavbarBackGround", self.NavbarBackGround);
          // console.log("SubNavbarBackGround", self.SubNavbarBackGround);

          await self.PlaceImage();
          self.flagNav = true;
        }
      } else if (self.$route.path.toLocaleLowerCase().match('fullstream') || self.$route.path.toLocaleLowerCase().match('snippet')) {
        let NavbarBackGround = await self.getIMG('NavBG.png');
        let IconChat = await self.getIMG('ChatIcon.png');
        let NavbarIcon = await self.getIMG('NavLogo.png');
        await Promise.all([IconChat, NavbarIcon, NavbarBackGround]).then(async (val) => {
          if (val[0] != null) {
            self.IconChat = val[0];
          }
          if (val[1] != null) {
            self.NavbarIcon = val[1];
          }
          if (val[0] != null || val[1] != null) {
            await self.PlaceImage();
            self.flagNav = true;
          }
          if (val[2] != null) {
            self.NavbarBackGround = val[2];

            // SET config background navbar fullStream set ตรงนี้เพราะแยก class fullstream-header-cover ออกมา
            let headerCoverElement = document.querySelector('.fullstream-header-cover');
            if (headerCoverElement != null) {
              headerCoverElement.style.setProperty('background', `url('${self.NavbarBackGround}')`, 'important');
              headerCoverElement.style.setProperty('background-position', 'center', 'important');
              headerCoverElement.style.setProperty('background-size', 'cover', 'important');
              headerCoverElement.style.setProperty('background-repeat', 'no-repeat', 'important');
            }
          }
        });
      }
    },
    PlaceImage() {
      let self = this;
      if (self.FontColorTitle != null) {
        let header_title = document.querySelectorAll('.header-title .title');
        if (header_title != null) {
          header_title.forEach((title) => {
            title.style.color = `#${self.FontColorTitle}`;
          });
        }
      }
      if (self.NavbarIcon != null) {
        let Fusion_Logo = document.querySelector('#Fusion_Logo_FullStream .v-image__image');
        if (Fusion_Logo != null) {
          Fusion_Logo.style.backgroundImage = `url('${self.NavbarIcon}') `;
        }
      }
      if (self.NavbarBackGround != null) {
        let headerCoverElement = document.querySelector('.header-cover');
        if (headerCoverElement != null) {
          headerCoverElement.style.setProperty('background', `url('${self.NavbarBackGround}')`, 'important');
          headerCoverElement.style.setProperty('background-position', 'center', 'important');
          headerCoverElement.style.setProperty('background-size', 'cover', 'important');
          headerCoverElement.style.setProperty('background-repeat', 'no-repeat', 'important');
        }
      }
      if (self.SubNavbarBackGround != null) {
        let headerTitleElement = document.querySelector('.header-title');
        if (headerTitleElement != null) {
          headerTitleElement.style.background = `url('${self.SubNavbarBackGround}') `;
        }
      }
    },
    async getIMG(filename) {
      const themeAssetUrl = this.getThemeAssetUrl(filename);
      if (themeAssetUrl) {
        this.countThemeImageLoad();
        return themeAssetUrl;
      }
      return await new Promise((resolve) => {
        this.$call.GetImage(
          filename,
          async (response) => {
            this.countThemeImageLoad();
            if (response.data.size === 0) {
              resolve(null);
            } else {
              const url = await window.URL.createObjectURL(new Blob([response.data]));
              resolve(url);
            }
          },
          () => {
            resolve(null);
          }
        );
      });
    },
    NotificationTokenExpired() {
      let self = this;
      self.$swal.fire({
        icon: 'error',
        title: 'Token has expired!!!',
        showConfirmButton: false,
      });
    },
  },
  updated() {
    let self = this;
    // if(!(self.$route.path != null && self.$route.path.toLocaleLowerCase() != '/configtheme')){
    self.PlaceImage();
    // }
  },
  async mounted() {
    let that = this;
    this.username = Cookies.get('username');
    this.roleId = Cookies.get('roleId');
    for (let key in that.$route.query) {
      that.parameterURL[key.toLowerCase()] = that.$route.query[key];
    }
    if (!(that.$route.path != null && that.$route.path.toLocaleLowerCase() != '/login')) {
      that.GetStartUpImage();
    }
    // S14-P3 fix — the /FullStreamV2 (snippet/fullstream) iframe never renders App.vue's NavBar
    // (showAppNavBar excludes it) and FullStreamReDesignV2 injects the snippet tokens but never
    // triggers a theme fetch, so configColor() never ran on this route → snippetShow* stayed null
    // → the login/translate/history gates defaulted to "show" (toggles appeared dead).
    // IMPORTANT: main.js calls app.mount() WITHOUT awaiting router.isReady(), so at mounted() the
    // initial route is still START_LOCATION ('/') — a plain path check here misses /FullStreamV2.
    // Gate on router readiness so we fetch once the real route (/FullStreamV2?...&companyId=) is
    // resolved. configColor() only (not GetStartUpImage) to skip the legacy fullstream image branch
    // that targets old .fullstream-header-cover / .header-cover classes (FullStreamReDesignV2 uses .fs2-*).
    that.$router.isReady().then(() => {
      const lp = (that.$route.path || '').toLocaleLowerCase();
      if (lp.match('snippet') || lp.match('fullstream')) that.configColor();
    });
    that.syncSnippetStatusFromRoute();
    // ตั้ง safety timer ไว้ปิด skeleton เผื่อ flag ยังค้างอยู่ (ไม่ให้ค้างถาวร)
    if (this.postLoginSkeleton) {
      this._postLoginSkeletonTimer = setTimeout(() => {
        this.postLoginSkeleton = false;
        sessionStorage.removeItem('_fusion_sa_navigating_from_login');
      }, 4000);
    }
  },
  beforeUnmount() {
    if (this._postLoginSkeletonTimer) {
      clearTimeout(this._postLoginSkeletonTimer);
      this._postLoginSkeletonTimer = null;
    }
    // 🔄 AMENDMENT 2026-09-03 (S14-P9 AC14) — cleanup hang timer
    if (this._snippetThemeHangTimer) {
      clearTimeout(this._snippetThemeHangTimer);
      this._snippetThemeHangTimer = null;
    }
  },
};
</script>
<style>
.v-content__wrap {
  background-color: #f0f0f7;
  min-height: calc(100vh - 64px);
  width: 100%;
}

.v-select.v-select--chips .v-select__selections {
  min-height: 42px !important;
}

/* เพิ่ม CSS เพื่อให้แน่ใจว่า Vuetify components มีขนาดเต็มจอ */
.v-application {
  min-height: 100vh !important;
  width: 100% !important;
}

.v-application__wrap {
  min-height: 100vh !important;
}

/* Global Skeleton loader overlay — pattern เดียวกับ Back to SuperAdmin ใน NavBar */
.superadmin-transition-shell {
  position: fixed;
  inset: 0;
  z-index: 99999;
  display: grid;
  grid-template-columns: 260px minmax(0, 1fr);
  background: #f5f7fa;
}

.superadmin-transition-sidebar {
  display: flex;
  flex-direction: column;
  gap: 18px;
  padding: 20px 16px;
  background: #f0f2f5;
  border-right: 1px solid rgba(23, 20, 76, 0.08);
}

.superadmin-transition-logo-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 6px 18px;
}

.superadmin-transition-logo-skeleton {
  width: 36px;
  height: 36px;
  flex: 0 0 36px;
}

.superadmin-transition-logo-text {
  flex: 1;
}

.superadmin-transition-menu {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.superadmin-transition-menu-item {
  border-radius: 16px;
  overflow: hidden;
}

.superadmin-transition-main {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.superadmin-transition-topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  min-height: 64px;
  padding: 0 24px;
  background: #ffffff;
  border-bottom: 1px solid rgba(23, 20, 76, 0.08);
}

.superadmin-transition-topbar-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.superadmin-transition-action {
  width: 34px;
  height: 34px;
}

.superadmin-transition-content {
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 24px;
}

.superadmin-transition-status {
  display: inline-flex;
  align-items: center;
  gap: 14px;
  align-self: flex-start;
  padding: 16px 18px;
  background: rgba(255, 255, 255, 0.94);
  border: 1px solid rgba(23, 20, 76, 0.08);
  border-radius: 18px;
  box-shadow: 0 18px 40px rgba(23, 20, 76, 0.08);
}

.superadmin-transition-title {
  font-size: 1rem;
  font-weight: 700;
  color: #17144c;
}

.superadmin-transition-subtitle {
  margin-top: 2px;
  font-size: 0.875rem;
  color: rgba(23, 20, 76, 0.68);
}

.superadmin-transition-hero {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.superadmin-transition-cards {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 16px;
}

.superadmin-transition-card {
  border-radius: 20px;
  overflow: hidden;
  min-height: 180px;
}

@media (max-width: 960px) {
  .superadmin-transition-shell {
    grid-template-columns: 1fr;
  }

  .superadmin-transition-sidebar {
    display: none;
  }

  .superadmin-transition-topbar {
    padding: 0 16px;
  }

  .superadmin-transition-content {
    padding: 16px;
  }

  .superadmin-transition-cards {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 600px) {
  .superadmin-transition-topbar-actions {
    gap: 8px;
  }

  .superadmin-transition-status {
    width: 100%;
  }

  .superadmin-transition-cards {
    grid-template-columns: 1fr;
  }
}
</style>
